export default "__VITE_ASSET__C4tI6jBF__"